import lodash from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { handleRecogniseChoose, newRectToBox } from '@/views/template-configuration/utils/js/help'
import { recognizeExamNo, setHandleVerticalCopyVal, bindThis } from '../js/recognise'
const fixRect = {
	data() {
		return {
			//no use
			currentObjName: '',
			//当前ppi 的pkId
			versionId: '',
			//原卷切块的 name
			tempSliceTopicName: '',
			textPaperIds: []
		}
	},
	watch: {
		tempSliceTopic(val) {
			this.tempSliceTopicName = val.name
			this.textPaperIds = val.idList
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'temObjFormat',
			'tempSubList',
			'tempObjTopic',
			'tempObjDirection',
			'tempFillDirection',
			'tempSelLikeSubOrObjVal',
			'tempSelLikeSubOrObj',
			'tempSelLikeSubOrObjName',
			'tempSliceTopic',
			'tempImgZoomRate',
			'canDrawRect'
		])
	},
	mounted() {
		bindThis(this)
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		...mapMutations('examination/configation', [
			'setCanDrawRect',
			'setCopyObjState',
			'setTempRectTitle',
			'setTempRotateArea',
			'setTempActiveArea',
			'setHandleSetObjVal',
			'setTempRightKeyFixRectInfo'
		]),
		// 拖拽或者缩放
		rectDragResize(newRect, index, isDone) {
			this.$nextTick(() => {
				let prevLeft = this.rectDetail[index].areaMinX
				let prevTop = this.rectDetail[index].areaMinY
				let prevHeight = this.rectDetail[index].areaMaxY - this.rectDetail[index].areaMinY
				let prevWidth = this.rectDetail[index].areaMaxX - this.rectDetail[index].areaMinX
				if (
					isDone &&
					this.tabActive === 'objective' &&
					(prevLeft > newRect.left || prevTop > newRect.top) &&
					(newRect.height > prevHeight || newRect.height > prevWidth)
				) {
					let intervalX = prevLeft - newRect.left,
						initervalY = prevTop - newRect.top
					let appendInfo = JSON.parse(this.rectDetail[index].appendInfo)
					let remarks = JSON.parse(this.rectDetail[index].remarks)
					let box = appendInfo.box
					let title = remarks.title
					box.forEach(res => {
						res.x += intervalX
						res.y += initervalY
					})
					title.forEach(res => {
						res.x += intervalX
						res.y += initervalY
					})
					appendInfo.box = box
					remarks.title = title
					this.rectDetail[index].appendInfo = JSON.stringify(appendInfo)
					this.rectDetail[index].remarks = JSON.stringify(remarks)
				}
				this.rectDetail[index].areaMinX = newRect.left
				this.rectDetail[index].areaMinY = newRect.top
				this.rectDetail[index].areaMaxX = newRect.left + newRect.width
				this.rectDetail[index].areaMaxY = newRect.top + newRect.height
				this.setTempRectTitle(this.rectDetail)
				this.refreshBoxDo(this.rectDetail[index], false)
			})
		},
		// 更新box
		refreshBoxDo(rectItem, flag = true) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: rectItem['pkId'],
				ppiStr: JSON.stringify(rectItem)
			}
			this.$post('Cv/refreshPpi', params).then(res => {
				this.setTempFlushData({ state: true })
				if (res.code === 200) {
					if (flag) this.setCanDrawRect(true)
					this.$message.success('成功')
				}
			})
		},
		// 删除区域
		dropArea(rectItem) {
			const _this = this
			function handleDropArea(rectItem, state) {
				const params = {
					subjectId: _this.query.subjectId,
					examId: _this.query.examId,
					ppiId: rectItem.pkId
				}
				_this.$post('Cv/rmPpi', params).then(async () => {
					if (state) {
						_this.setTempFlushData({ state: true })
						_this.$message({ type: 'success', message: '删除成功' })
					}
					let tempCurSubIndex = await _this.get({ dbName: 'database', path: 'tempCurSubIndex', defaultValue: 0, user: true })
					let currentRect = JSON.parse(rectItem.remarks).bigNum
					tempCurSubIndex[currentRect] -= 1
					_this.set({ dbName: 'database', path: 'tempCurSubIndex', value: tempCurSubIndex, user: true })
				})
			}
			if (rectItem.state) {
				this.$confirm('删除区块, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						handleDropArea(rectItem.val, true)
					})
					.catch(() => {
						this.$message.info('取消删除')
					})
			} else {
				handleDropArea(rectItem.val, false)
			}
		},
		// 新增   kwargs = {}
		async addDropRect(areaMaxX, areaMaxY, areaMinX, areaMinY, appendInfoBox = [], boxTitle = [], handleOrigin = []) {
			let tempCurSubIndex = await this.get({ dbName: 'database', path: `tempCurSubIndex.${this.tempSubList.name}`, defaultValue: 0, user: true })
			let objFormat = JSON.parse(lodash.cloneDeep(this.temObjFormat))
			let params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId
			}
			const infos = {
				areaMaxX,
				areaMaxY,
				areaMinX,
				areaMinY,
				zoomRatioX: 1,
				zoomRatioY: 1,
				examId: this.query.examId,
				examSubjectId: this.query.subjectId,
				pageSizeMaxX: this.tempImgZoomRate.pageWidth,
				pageSizeMaxY: this.tempImgZoomRate.pageHeight,
				paperSizeMaxX: this.tempImgZoomRate.pageWidth,
				paperSizeMaxY: this.tempImgZoomRate.pageHeight
			}
			objFormat = Object.assign({}, objFormat, infos)
			let areaType = null,
				areaName = null,
				remarks = {},
				append = objFormat.appendInfo
			if (this.tabActive === 'title') {
				areaType = 2
				areaName = '标题'
				remarks = { desc: '标题' }
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { wolds: [] }))
			} else if (this.tabActive === 'examNo') {
				areaType = 8
				areaName = '考号区域'
				remarks = {
					type: this.tempExamNoType,
					desc: '考号区域'
				}
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { box: appendInfoBox, type: this.tempExamNoType }))
			} else if (this.tabActive === 'objective') {
				if (this.tempTopicCurrentIndex === -1) {
					this.$message.error('请选择客观题题块')
					return false
				}
				areaType = 16
				areaName = '客观题'
				let name = this.tempObjTopic.reduce((acc, val) => (acc += val.key), '')
				remarks = {
					name,
					desc: '客观题',
					align: this.tempObjDirection,
					title: boxTitle,
					handleOrigin
				}
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { box: appendInfoBox, title: boxTitle }))
			} else if (this.tabActive === 'subjective') {
				areaType = 32
				areaName = '主观题'
				params.paperRangeId = this.tempSubList.paperRangeId
				remarks = {
					desc: '主观题',
					bigNum: this.tempSubList.name
				}
				tempCurSubIndex += 1
				if (this.tempSubList?.name) {
					this.set({ dbName: 'database', path: `tempCurSubIndex.${this.tempSubList.name}`, value: tempCurSubIndex, user: true })
				}
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { paperRangeId: this.tempSubList.paperRangeId }))
			} else if (this.tabActive === 'slice') {
				areaType = 64
				areaName = '原卷切块'
				remarks = { desc: '原卷切块', title: this.tempSliceTopicName }
				params.textPaperIds = JSON.stringify(this.textPaperIds)
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { textPaperIds: this.textPaperIds }))
			} else if (this.tabActive === 'choose') {
				areaName = '选做题'
				let remark = {
					desc: areaName,
					selectName: this.tempSelLikeSubOrObjName
				}
				if (this.tempSelLikeSubOrObj === 'sub') {
					areaType = 32
					params.paperRangeId = this.tempSelLikeSubOrObjVal.paperRangeId
					remarks = Object.assign({}, remark, { type: 'likeSub', bigNum: this.tempSelLikeSubOrObjVal.name, isLikeSub: true })
					objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { wolds: [], paperRangeId: this.tempSelLikeSubOrObjVal.paperRangeId }))
				} else if (this.tempSelLikeSubOrObj === 'obj') {
					areaType = 128
					remarks = Object.assign({}, remark, { type: 'likeObj' })
					objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { box: appendInfoBox, title: boxTitle }))
				}
			} else if (this.tabActive === 'lack') {
				areaType = 256
				areaName = '缺考'
				remarks = { type: this.tempExamNoType, desc: '缺考' }
				objFormat.appendInfo = JSON.stringify(Object.assign({}, append, { box: appendInfoBox, type: this.tempExamNoType }))
			}
			remarks.page = this.tempCurrentImgIndex.curIndex + 1
			remarks.version = this.tempEditImgInfo.versionId
			remarks.isPermitDo = false
			objFormat.remarks = JSON.stringify(remarks)
			objFormat.areaName = areaName
			objFormat.areaType = areaType
			params = Object.assign({}, params, { ppiStr: JSON.stringify(Object.assign(objFormat, { areaType, areaName })) })
			this.$post('Cv/addPpi', params).then(() => {
				this.$message({ message: '新增成功', type: 'success' })
				this.setTempFlushData({ state: true })
			})
		},
		// 框子外面的那个下拉框
		dropDownMenu(command, comandVal) {
			switch (command) {
				case 'del':
					this.dropArea({ val: comandVal.val, state: true })
					break
				case 'drag':
					this.setCanDrawRect(false)
					this.setTempActiveArea(comandVal.curIndex)
					break
				case 'rotate':
					this.setTempRotateArea({ rectIndex: comandVal.curIndex, rectVal: comandVal.val })
					break
				case 'copy':
					if (this.tempObjTopic.length === 0) {
						this.$message.error('请选择客观题题号')
						return
					}
					if (!JSON.parse(comandVal.val.appendInfo).box[0].n) {
						this.$message.error('请先设置初始题号')
						return
					}
					this.handleCopyObj(comandVal)
					this.setCopyObjState({ state: true })
					break
				case 'completeCopy':
					this.setCopyObjState({ state: false })
					break
				case 'init':
					if (this.tempObjTopic.length === 0) {
						this.$message.error('请选择客观题题号')
						return
					}
					this.setHandleSetObjVal({ state: true, val: comandVal.val })
					break
				case 'setRow':
					this.resetRowNumObj(comandVal)
					break
			}
		},
		//复制客观题
		handleCopyObj(comandVal) {
			let rectGapX = 100,
				rectGapY = 0,
				rectHeight = 0,
				rectWidth = 0,
				tempRectObjectiveVal = this.tempRectObjective.val
			const values = comandVal.val
			let width = values.areaMaxX - values.areaMinX
			const len = tempRectObjectiveVal.length
			if (len > 1) {
				rectGapX = tempRectObjectiveVal[1].areaMinX - tempRectObjectiveVal[0].areaMaxX
				rectHeight = tempRectObjectiveVal[len - 1].areaMaxY - tempRectObjectiveVal[len - 1].areaMinY
				rectWidth = tempRectObjectiveVal[len - 1].areaMaxX - tempRectObjectiveVal[len - 1].areaMinX
			}
			if (rectGapX < 0) rectGapX = 100
			let isNewRow = false
			if (tempRectObjectiveVal[tempRectObjectiveVal.length - 1].areaMaxX + rectWidth + rectGapX >= this.tempImgZoomRate.pageWidth) {
				rectGapY = rectHeight + 100
				isNewRow = true
			}

			let areaMaxY = values.areaMaxY + rectGapY
			let areaMinY = values.areaMinY + rectGapY
			let areaMaxX = values.areaMaxX + width + rectGapX
			let areaMinX = values.areaMinX + width + rectGapX

			let box = JSON.parse(values.appendInfo).box
			let title = []
			let handleOrigin = JSON.parse(values.remarks).handleOrigin || []
			//1。题号方向水平,填图方向竖直    2。题号方向竖直  填图方向水平
			if ((this.tempFillDirection === 'H' && this.tempObjDirection === 'V') || (this.tempFillDirection === 'V' && this.tempObjDirection === 'H')) {
				const infos = setHandleVerticalCopyVal(comandVal, this.tempObjTopic, this.tempFillDirection)
				if (!infos) {
					this.$message.error('复制失败')
					return
				}
				width = infos.OtherInfo.areaMaxX - infos.OtherInfo.areaMinX
				areaMaxX = infos.OtherInfo.areaMaxX + width + rectGapX
				areaMinX = infos.OtherInfo.areaMinX + width + rectGapX
				areaMinY = infos.OtherInfo.areaMinY + rectGapY
				areaMaxY = infos.OtherInfo.areaMaxY + rectGapY
				box = infos.box
				title = infos.title
				handleOrigin = []
			}

			if (isNewRow) {
				areaMinX = tempRectObjectiveVal[0].areaMinX
				areaMaxX = tempRectObjectiveVal[0].areaMaxX
			}

			this.addDropRect(areaMaxX, areaMaxY, areaMinX, areaMinY, box, title, handleOrigin).then(() => {
				this.setCanDrawRect(false)
				this.setTempActiveArea((comandVal.curIndex += 1))
				if (this.tempFillDirection == 'V') {
					this.initHandleTopic += comandVal.val.titleList.length
				} else {
					this.initHandleTopic += comandVal.val.titleList.length
				}
			})
		},
		// 设置行数
		resetRowNumObj(comandVal) {
			this.$resetRow(comandVal.val, this.tempObjDirection)
		},
		//--------------------------------------------
		//鼠标右键， 新增  缺考  客观题，
		addRect(event, rectItem) {
			if (event.target === event.currentTarget && event.button === 2) {
				const info = {
					rectItem,
					left: event.offsetX,
					top: event.offsetY,
					examId: this.query.examId,
					subjectId: this.query.subjectId,
					versionId: this.tempEditImgInfo.versionId,
					direction: this.tempObjDirection || '',
					subOrObjVal: this.tempSelLikeSubOrObjVal
				}
				newRectToBox(this, info).then(res => {
					if (res.code === 200) {
						// console.log('this.tabActive',this.tabActive);
						// console.log('res.data.boxFromAppendInfo.length',res.data.boxFromAppendInfo.length);
						// console.log('this.tempSelLikeSubOrObjVal.length',this.tempSelLikeSubOrObjVal.length);
						if (this.tabActive === 'choose' && res.data.boxFromAppendInfo.length === this.tempSelLikeSubOrObjVal.length) {
							console.log('00000000')
							this.addOperateSelect(res.data.boxFromAppendInfo, rectItem)
						} else {
							this.setTempFlushData({ state: true })
						}
					}
				})
			}
		},
		// 新增的时候，操作选做题
		addOperateSelect(boxFromAppendInfo, rectItem) {
			const _this = this
			handleRecogniseChoose(boxFromAppendInfo, this.tempSelLikeSubOrObjVal).then(resp => {
				const appendInfo = JSON.parse(rectItem.appendInfo)
				appendInfo.box = resp
				rectItem.appendInfo = JSON.stringify(appendInfo)
				_this.refreshBoxDo(rectItem)
			})
		},
		// 考号 点击右键，直接新增
		addExamNoRect(event, rectItem) {
			if (event.target === event.currentTarget && event.button === 2) {
				let map = {}
				const top = event.offsetY
				const box = JSON.parse(rectItem.appendInfo).box
				box.forEach(res => {
					map[`${res.v}-${res.x}`] = Math.abs(res.y - top)
				})
				let resMap = Math.min(...Object.values(map))
				let noVal = null
				for (let key in map) {
					if (map[key] === resMap) {
						noVal = key.split('-')[0]
						break
					}
				}
				const params = {
					rectItem,
					value: noVal,
					left: event.offsetX,
					top: event.offsetY,
					examId: this.query.examId,
					subjectId: this.query.subjectId,
					versionId: this.tempEditImgInfo.versionId,
					direction: this.tempObjDirection || '',
					subOrObjVal: this.tempSelLikeSubOrObjVal
				}
				newRectToBox(this, params).then(res => {
					if (res.code === 200) {
						let ppis = res.data
						let appendInfo = JSON.parse(ppis.appendInfo)
						let box = appendInfo.box
						if (box.length % 10 === 0) {
							appendInfo.box = recognizeExamNo(this, box, [], true)
							ppis.appendInfo = JSON.stringify(appendInfo)
							this.refreshBoxDo(ppis)
						} else {
							this.setTempFlushData({ state: true })
						}
					}
				})
			}
		},
		//  鼠标右键操作 编辑当前rect,title 删除或修改
		fixRectList(event, rectItem, item, rectIndex, index, isTitle = false) {
			if (event.target === event.currentTarget && event.button === 2) {
				const rightKeyInfo = {
					top: Number(rectItem.areaMinY) + Number(item.y),
					left: Number(rectItem.areaMinX) + Number(item.x),
					ppi: item,
					ppiIndex: index,
					rectIndex,
					rectItem,
					isTitle
				}
				this.setTempRightKeyFixRectInfo(rightKeyInfo)
			} else if (event.target === event.currentTarget && event.button === 0 && this.tabActive === 'examNo') {
				this.moveExamNoMouseDown(index)
			}
		}
	}
}
export default fixRect
